/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import styled from "@emotion/styled";
import { theme } from "styles/theme";
import { useEffect } from "react";
import Button from "uis/Button";
import Icon from "uis/Icon";
import VisitSlackMessageImg from "../../../../assets/imgs/visitors-onboard/visit-slack-message.png";
import SlackLogo from "../../../../assets/imgs/slack-logo.png";
import { ConfirmVisitProcess } from "./process/confirmVisitProcess";
import { gaEvent } from "utils/ga-utils";

const RootContainer = styled.div`
    display: flex;
    flex-direction: column;

    width: 100%;
    height: 100%;
`;

const Process = styled.div`
    height: 20%;
    display: flex;
    justify-content: center;
    align-items: center;

    background-color: ${theme.neutral50};
`;

const ImageContent = styled.div`
    height: 42%;

    display: flex;
    flex-direction: row;
    gap: 80px;
    justify-content: center;
    align-items: center;
`;

const InfoContent = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 30px;

    height: 23%;
    background-color: ${theme.neutral50};
`;
const Title = styled.div`
    font-size: 24px;
    font-weight: 500;
    color: ${theme.neutral900};

    display: flex;
    justify-content: center;
    align-items: center;
`;
const SubText = styled.div`
    font-size: 18px;
    font-weight: 500;
    color: ${theme.neutral600};
    text-align: center;
    line-height: 160%;

    display: flex;
    flex-direction: row;
    gap: 2px;
`;

const Footer = styled.div`
    height: 15%;

    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    box-sizing: border-box;
    padding: 0px 50px;
    width: 100%;
    background-color: ${theme.neutral50};
`;
const ButtonContainer = styled.div`
    display: flex;
    flex-direction: row;
    gap: 16px;
    margin-left: auto;
`;

type Props = {
    isFirst: boolean;
    onClickFinish: () => void;
    onClickBack: () => void;
}

export default function ConfirmVisitPage(props: Props) {
    const { isFirst, onClickFinish, onClickBack } = props;

    useEffect(() => {
        if (isFirst) {
            gaEvent("첫 온보딩 - 방문 확인하기");
        } else { 
            gaEvent("온보딩 - 방문 확인하기");
        }
    }, []);

    return (
        <RootContainer>
            <Process>
                <ConfirmVisitProcess></ConfirmVisitProcess>
            </Process>
            <ImageContent>
                <Icon name="confirm-alarm-illust" color={theme.primary500} width={260}/>
                <div css={css`
                    display: flex;
                    flex-direction: column;
                    gap: 20px;
                `}>
                    <img width="30" src={SlackLogo} />
                    <img width="460" src={VisitSlackMessageImg} alt="VisitSlackMessageImg"></img>
                </div>
            </ImageContent>
            <InfoContent>
                <Title>방문자가 도착하면 슬랙으로 도착 알림을 받을 수 있어요!</Title>
                <SubText>
                    방문 안내를 받은 방문자를 우리 회사 앞에 놓인 태블릿을 활용해서 담당자를 호출할 수 있어요!<br/>
                    슬랙으로 편하게 도착 알림을 받아보세요.
                </SubText>
            </InfoContent>
            <Footer>
                <ButtonContainer>
                    <Button
                        title="이전"
                        type="secondary"
                        styles={{
                            container: css`
                                width: 120px;
                                height: 63px;
                            `,
                            text: css`
                                font-size: 18px;
                            `,
                        }}
                        onClick={onClickBack}
                    />
                    <Button
                        title="완료"
                        type="primary"
                        styles={{
                            container: css`
                                width: 260px;
                                height: 63px;
                            `,
                            text: css`
                                font-size: 18px;
                            `,
                        }}
                        onClick={onClickFinish}
                    />
                </ButtonContainer>
            </Footer>
        </RootContainer>
    );
}
